import { Component, ViewChild } from '@angular/core';
import { Form, FormCreatorService } from 'lib-base';
import { FormDesignerComponent } from '../../../components/form-builder-components/form-designer/form-designer.component';
import { FormConfigurationComponent } from '../../../components/form-builder-components/form-configuration/form-configuration.component';
import { SplitterModule } from 'primeng/splitter';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-form-designer-container',
  standalone: true,
  imports: [FormDesignerComponent, FormConfigurationComponent, SplitterModule, CommonModule],
  providers: [FormCreatorService],
  template: `
  <p-splitter [style]="scrollPanel" [minSizes]="[0,20]" [panelSizes]="[70,30]" styleClass="mb-5">
    <ng-template pTemplate>
      <div class="w-full overflow-y-auto">
        <app-form-designer></app-form-designer>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="w-full overflow-y-auto">
        <app-form-configuration></app-form-configuration>
      </div>
    </ng-template>
  </p-splitter>
  `
})
export class FormDesignerContainerComponent {
  scrollPanel: any = { width: '100%', height: '65vh' };

  @ViewChild(FormDesignerComponent) designerComponent !: FormDesignerComponent;
  @ViewChild(FormConfigurationComponent) formConfigurationComponent !: FormConfigurationComponent;

  constructor(public fc: FormCreatorService) {
    const options = {
      isDesigner: true,
      enableSubmit: false
    }
    this.fc.setOptions(options);
  }

  public loadForm(response: Form) {
    this.fc.loadForm(response);
    setTimeout(() => {
      this.formConfigurationComponent.initializeCurrentMenu();
    });
  }

  public initializeNewForm() {
    this.fc.initializeNewForm();
  }
}
